var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseContainer',[(_vm.$usesFeature('classic-jobs'))?_c('AssessmentList'):_c('JobsEnhanced')],1)}
var staticRenderFns = []

export { render, staticRenderFns }